import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=3b3d5276&scoped=true&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=3b3d5276&prod&lang=scss&"
import style1 from "./PrivacyPolicy.vue?vue&type=style&index=1&id=3b3d5276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d5276",
  null
  
)

export default component.exports